// BSGOTECH / HX ECOSYSTEMS image system.
// Visual strategy: realistic, human-scale, credible African-island context.
// "Show the idea, not fake scale." No megaprojects, no fake factories/skyscrapers.
// 2026-06 refresh: contemporary (2024–2026) realistic island visuals — modern vehicles,
// well-maintained homes, current technology. Human presence WITHOUT identifiable faces
// (people shown from behind/side/over-the-shoulder, hands on devices, or at a distance).
const P = "https://static.prod-images.emergentagent.com/jobs/7049cfc9-7ec3-447e-bc01-459dac5aa6d7/images/";

export const IMAGES = {
  // Homepage hero — contemporary island town, well-kept homes, current cars, people from behind
  hero_modular: P + "10e8f8d4d169b9e5e51aaa56507a61ae5ffe59f0f5c032c654029db530ccc242.jpeg",
  integrated_aerial: P + "10e8f8d4d169b9e5e51aaa56507a61ae5ffe59f0f5c032c654029db530ccc242.jpeg",

  // HX Solar — modest well-maintained island home with rooftop solar + compact battery
  solar_energy: P + "90f24d43c46f59e0c1d4cd0632982616768e5f27687496d82bb6a994e3e49a3d.jpeg",
  hx_ecosystems_tropical: "/images/hx-ecosystems-tropical-v2.jpg",
  bsgotech_trade_family: "/images/bsgotech-trade-family-v2.jpg",

  // HX E-Mobility — contemporary island street, compact EV charging, recent EV, app (over-shoulder)
  battery_hub: P + "9c77167a91438252b103ab2e487f1fe04c0079cb82c9d04faedfa268fabcec54.jpeg",

  // HX Modular — small modern modular community building, people from behind for scale
  modular_general: P + "7d104fcbda48ce8acde863e0ee4659744edafab288a95de97facd9edd17249f6.jpeg",

  // Use-case home — solar + battery + EV + smartphone (hands only), person from behind
  habitacao_energy: P + "4a7cb4fa97d99c65e6edfd9431ab59b283a46d3c225a2588f25c11ee0a0fb200.jpeg",
  home_solution: P + "4a7cb4fa97d99c65e6edfd9431ab59b283a46d3c225a2588f25c11ee0a0fb200.jpeg",

  // HX Digital / NEXIS — local operator (from behind) with modern laptop/tablet + dashboard
  digital_ops: P + "8d08f0b75e6666cd413ff78cd0404daf19375af8488330f916bb7caebeca4328.jpeg",
  escritorio_modular: P + "dc446c0206aa579d14fbb2dd6af477c4392dea49ed2b6ce8806c3c623eec243b.jpeg",

  // Small-scale solar water pumping on an island farm (agri / water, modest)
  energy_install: P + "4554c8529fa74d5f2eeed0ce0a10a1fced8657ff50a7e7851469b387365b5cc1.jpeg",

  // Contemporary modular commercial / local market
  mercado_modular: P + "9ed5a24538ba42163db515452c31f3b357c24488ff4b675c87e15e30ee9b0147.jpeg",
  business_solution: P + "9ed5a24538ba42163db515452c31f3b357c24488ff4b675c87e15e30ee9b0147.jpeg",
  wc_plus: P + "9ed5a24538ba42163db515452c31f3b357c24488ff4b675c87e15e30ee9b0147.jpeg",
  ponto_infantil: P + "7141834d8b86276f4ad3d0cc4147942e3ed4fcea4a26d53f59b9a874c0b38461.jpeg",
  ponto_saude: P + "9bc15355f4a820b500e353ae318f435c4d4fa7f4d59a17cddff1bdebafd313d4.jpeg",
  community: P + "7d104fcbda48ce8acde863e0ee4659744edafab288a95de97facd9edd17249f6.jpeg",
  eco_lodge: P + "cb11e1bc5be408164b1adbebba4c783b87de8769c40e0bd4ee73b7907e9de231.jpeg",
  partner_network: P + "29baa9bf81c902c9419ebc1ea64aed97776b32ac8d0a18ac4e0a6fd7f040d8ad.jpeg",
  stp_landscape: P + "d1e46cc8b955d939e1b7f520519962cfe64bcc7f0bf9da67156c16c20260cb36.jpeg",

  // Division / project dedicated visuals (contemporary, realistic, no visible faces)
  eco_collection: P + "7c1c78f688c38b323a1aabeb871cf4df6b8335d2b07be5f23f68d4b2c39d158d.jpeg",
  nu_bai: P + "6113e413582eb3a1e2096b6bd804f14273184ff69b813cff729e40005c7b46fb.jpeg",
  obogo: P + "d1e46cc8b955d939e1b7f520519962cfe64bcc7f0bf9da67156c16c20260cb36.jpeg",
  obo_pay: P + "7e526256e3b06f1afc4890671dc711273f93e3ae9c371bedaeeab55490a3e2b9.jpeg",
  nubai_move: P + "6113e413582eb3a1e2096b6bd804f14273184ff69b813cff729e40005c7b46fb.jpeg",
  nubai_pay: P + "7291f574685568425cd3bad0968f6b5cace4ef03b6e7fd3706a711773d25f0ab.jpeg",
  nubai_point: P + "9965deb40455d2f6dba03330882bba21d6605e1ff9ca28404dcfcf6b8cbe130f.jpeg",

  // BSGOTECH origin story (contemporary, realistic, no visible faces)
  story_principe: P + "80aaab718bcd43c786150e67796978f63b40adb13c404b85161aea11b378e562.jpeg",
  story_europe: P + "1d2ced4398ec4ca2bdb3735ccd55004677721b7c199c42024051b974efebb332.jpeg",

  // Global Network — light minimal dotted world map (white bg, no labels)
  world_map_light: P + "10ca7e2890a5f8a5bd07784cd739bba079dd04dd0cca67dfadd6da765297958a.jpeg",

  // Global Sourcing — international container logistics (editorial hero)
  global_sourcing_logistics: "https://images.unsplash.com/photo-1494412519320-aa613dfb7738?auto=format&fit=crop&w=2000&q=86",

  // Editorial corporate imagery — neutral representations, never presented as owned assets or staff
  technical_training: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1800&q=84",
  network_collaboration: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1800&q=84",
  project_execution: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1800&q=84",
  quality_inspection: "https://images.unsplash.com/photo-1567789884554-0b844b597180?auto=format&fit=crop&w=1600&q=84",

  // BSGOTECH Trade — category-led editorial photography
  trade_women: "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=900&q=82",
  trade_men: "https://images.unsplash.com/photo-1617137968427-85924c800a22?auto=format&fit=crop&w=900&q=82",
  trade_children: "https://images.unsplash.com/photo-1607453998774-d533f65dac99?auto=format&fit=crop&w=900&q=82",
  trade_resale: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=900&q=82",

  // Homepage hero — real aerial photograph of São Tomé supplied by BSGOTECH
  stp_hero_coast: "/images/bsgotech-sao-tome-hero.jpg",

  // HX family — real product photography (catalog)
  fam_energy: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  fam_water: "https://images.unsplash.com/photo-1533163238111-4a7ced54f2e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  fam_modular: "https://images.unsplash.com/photo-1728344430621-f6b58ef4a108?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  fam_mobility: "https://images.unsplash.com/photo-1558978806-73073843b15e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  fam_bio: "https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  fam_medicare: "https://images.unsplash.com/photo-1564420228450-d9a5bc8d6565?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  fam_spaces: "https://images.unsplash.com/photo-1715593949273-09009558300a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  fam_play: "https://images.unsplash.com/photo-1758278038636-3936fafd057e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const img = (key) => {
  if (typeof key === "string" && (key.startsWith("http") || key.startsWith("/api/"))) return key;
  return IMAGES[key] || IMAGES.modular_general;
};
